import LandEditPage from './LandEditPage.container'
export default LandEditPage
